import React, { useMemo } from "react";
import List from "@material-ui/core/List";
import { Fetcher } from "../../Fetcher";
import { getPowUserAuditHistory } from "../../../services/api/userAdministration.api";
import { MessageCard } from "../../MessageCard";
import { ListItem } from "@material-ui/core";
import { UserAuditHistoryResponse } from "../../../models/Administration";
import { UserAuditHistoryStepDisplayCard } from "./UserAuditHistoryStepDisplayCard";

interface UserAuditHistoryProps {
	//The user name to fetch and display the audit history for.
	userPrincipalName: string;
}

const renderAuditHistory = (data: UserAuditHistoryResponse[]) => {
	return (
		<div data-testid="user-list">
			{data && data.length > 0 ? (
				<List>
					{data.map((step) => (
						<ListItem key={Math.random()} data-testid="user-list-item">
							<UserAuditHistoryStepDisplayCard AuditHistoryStep={step}></UserAuditHistoryStepDisplayCard>
						</ListItem>
					))}
				</List>
			) : (
				<MessageCard message="Audit history for user not found." textAlign="left" />
			)}
		</div>
	);
};

/**
 * Fetch and display a list of a users audit history and displays
 * those steps in a list of UserAuditHistoryStepDisplayCard
 * @param props
 */
export const UserAuditHistory = (props: UserAuditHistoryProps) => {
	return (
		<div>
			{useMemo(() => {
				return (
					<Fetcher action={getPowUserAuditHistory(props.userPrincipalName)}>
						{(response) => renderAuditHistory(response && response.data)}
					</Fetcher>
				);
			}, [props.userPrincipalName])}
		</div>
	);
};
